module.exports = __webpack_public_path__ + "img/CattleyaoneHandedSword_02.9e353938.png";